import React from 'react';
import { Layout } from '.';

const Institucional = (props) => (
  <Layout>
    <section className="page-institucional">
      <section className="main">
        <header>
          <img src={require('../img/logo-color.svg')} className="logo" />

          <h2>A sua área de benefícios.</h2>

          <ul>
            <li>
              <img src={require('../img/icon-platform.svg')} />
              <span>Plataforma</span>
            </li>
            <li>
              <img src={require('../img/icon-broker.svg')} />
              <span>Corretora</span>
            </li>
            <li>
              <img src={require('../img/icon-advisory.svg')} />
              <span>Assessoria</span>
            </li>
          </ul>
        </header>
      </section>

      <div className="content-container">
        <div className="bg" />
        <section className="main">
          <div className="content-about">
            <p>A <strong>D2PAR</strong> surgiu com o objetivo de ajudar corretores que não possuem expertise no segmento de plano de saúde, mesmo com o mais alto potencial de mercado.</p>
            <p>Com o tempo, identificamos que corretores que já atuam no ramo também podem se beneficiar de uma assessoria especializada que, de alguma forma, se transformou em uma aliada comercial e administrativa, como se pertencesse à um departamento específico da corretora.</p>
            <p>A D2PAR é mais que uma assessoria, nosso compromisso é com o corretor e seu cliente, buscando oferecer a solução personalizada para cada um.</p>

            <div className="content-about-units">
              <h2>Unidades</h2>
              <p>Atendimento e parceria em todo o território nacional, e seguro saúde internacional com cobertura mundial.</p>
              <div className="unit">
                <img src={require('../img/img-unidade-jundiai.jpg')} alt="Unidade Jundiaí/SP" />
                <div>
                  <strong>Jundiaí/SP</strong>
                  <span>R. Cap. Cassiano Ricardo de Toledo, 191 - sala 203 Chácara Urbana, Jundiaí</span>
                </div>
              </div>

              <div className="unit">
                <img src={require('../img/img-unidade-uberlandia.jpg')} alt="Uberlândia/MG" />
                <div>
                  <strong>Uberlândia/MG</strong>
                  <span>Av. dos Vinhedos, 70 - Sala 001, Morada da Colina, Uberlândia</span>
                </div>
              </div>

            </div>
          </div>

          <div className="content-history">
            
            <h2>Nossa história</h2>
            <ul>
              <li>
                <img src={require('../img/icon-history-1.svg')} />
                <div>
                  <strong className="year">2011</strong>
                  <span>Abre a corretora</span>
                </div>
              </li>
              <li>
                <img src={require('../img/icon-history-2.svg')} />
                <div>
                  <strong className="year">2014</strong>
                  <span>Nasce a plataforma com atendimento ao corretor</span>
                </div>
              </li>
              <li>
                <img src={require('../img/icon-history-3.svg')} />
                <div>
                  <strong className="year">2017</strong>
                  <span>Nos tornamos D2PAR com foco total no canal corretor</span>
                </div>
              </li>
              <li>
                <img src={require('../img/icon-history-4.svg')} />
                <div>
                  <strong className="year">2022</strong>
                  <span><strong>D2PAR é grupo!</strong><br/>Com mais vertentes de negócios e novas soluções que agregam para o marcado securitário</span>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <section className="main">
        <ul className="stats">
          <li>
            <strong>+900</strong>
            <span>corretores ativos</span>
          </li>
          <li>
            <strong>+17mil</strong>
            <span>clientes atendidos</span>
          </li>
          <li>
            <strong>+28mil</strong>
            <span>beneficiários ativos</span>
          </li>
        </ul>
        <img src={require('../img/d2par-group.jpg')} className="group" />
      </section>

      <div className="icons">
        <section className="main">
          <ul>
            <li>
              <img src={require('../img/icon-mission.svg')} />
              <strong>Missão</strong>
              <span>Estar sempre à frente do tempo com a essência de levar benefício de qualidade e o objetivo de assegurar proteção e segurança para todos os brasileiros.</span>
            </li>
            <li>
              <img src={require('../img/icon-vision.svg')} />
              <strong>Visão</strong>
              <span>Ser referência em atendimento no mercado de benefícios, se tornando uma empresa líder em prestação de serviço e modelo de inspiração e aprendizado a todos.</span>
            </li>
            <li>
              <img src={require('../img/icon-values.svg')} />
              <strong>Valores</strong>
              <span>Ética profissional; respeito; franqueza; objetividade e relações de confiança.</span>
            </li>
          </ul>
        </section>
      </div>

      <div className="content-prizes">
        <div className="content-prizes-wrapper">
          <section className="main">
            <h2>Premiações<br /> mais recentes</h2>
            <img src={require('../img/img-prizes.png')} />
          </section>
        </div>
        <section className="main">
          <ul>
            <li>
              <strong>2019</strong>
              <span>Talentos Bradesco</span>
            </li>
            <li>
              <strong>2020</strong>
              <span>PRA SulAmérica</span>
            </li>
            <li>
              <strong>2021</strong>
              <span>PRA SulAmérica <br/>Amil Exterts - PJ</span>
            </li>
            <li>
              <strong>2022</strong>
              <span>PRA SulAmérica Amil Massificado - PME</span>
            </li>
          </ul>
        </section>
      </div>

      <div className="footer">
        <section className="main">
          <ul className="address">
            <li>
              <strong>Unidade Jundiaí/SP</strong>
              <span>(11) 97884-5177</span>
            </li>
            <li>
              <strong>Unidade Uberlândia/MG</strong>
              <span>(34) 98407-0046</span>
            </li>
          </ul>

          <ul className="social-networks">
            <li>
              <a href="https://www.facebook.com/d2parbeneficios" target="_blank">
                <img src={require('../img/icon-about-facebook.svg')} alt="Facebook" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/d2parbeneficios" target="_blank">
                <img src={require('../img/icon-about-instagram.svg')} alt="Instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/d2par-assessoria" target="_blank">
                <img src={require('../img/icon-about-linkedin.svg')} alt="LinkedIn" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@d2parbeneficios268" target="_blank">
                <img src={require('../img/icon-about-youtube.svg')} alt="Youtube" />
              </a>
            </li>
          </ul>
        </section>
      </div>

    </section>
  </Layout>
);

export default Institucional;


// WEBPACK FOOTER //
// ./src/screens/Institucional.js